import { render } from "./GenieIcon.vue?vue&type=template&id=60eb43a9"
import script from "./GenieIcon.vue?vue&type=script&lang=js"
export * from "./GenieIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__